import { Navigate, Outlet } from "react-router-dom";

const AUTH_KEYS = [
  "authenticated",
  "userId",
  "session_token",
  "userName",
  "userEmail",
];

const hydrateSessionStorage = () => {
  AUTH_KEYS.forEach((key) => {
    const localValue = localStorage.getItem(key);
    const sessionValue = sessionStorage.getItem(key);

    if (!sessionValue && localValue) {
      sessionStorage.setItem(key, localValue);
    }
  });
};

const PublicRoute = () => {
  hydrateSessionStorage();

  const isAuthenticated =
    sessionStorage.getItem("authenticated") === "true" ||
    localStorage.getItem("authenticated") === "true";

  return !isAuthenticated ? <Outlet /> : <Navigate to="/home" replace />;
};

export default PublicRoute;